import React from 'react';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

function Privacy() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
      <Navbar />
      <div style={{ padding: isMobile ? '1rem' : '2rem', maxWidth: '800px', margin: '0 auto' }}>

        <button style={{ backgroundColor: 'transparent', border: `1px solid ${colors.border}`, color: colors.textSecondary, borderRadius: '20px', padding: '0.4rem 1rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.9rem', marginBottom: '1.5rem' }} onClick={() => navigate(-1)}>
          <ArrowBackIcon style={{ fontSize: 16 }} /> Volver
        </button>

        <h1 style={{ color: colors.text, fontSize: isMobile ? '1.4rem' : '2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>Política de privacidad</h1>
        <p style={{ color: colors.textSecondary, fontSize: '0.9rem', marginBottom: isMobile ? '1.5rem' : '3rem' }}>Última actualización: abril de 2026</p>

        {[
          {
            title: '1. Responsable del tratamiento',
            content: 'Galiticket es el responsable del tratamiento de los datos personales recogidos a través de esta plataforma. Para cualquier consulta relacionada con la privacidad puedes contactarnos en info@galiticket.es.'
          },
          {
            title: '2. Datos que recopilamos',
            content: 'Recopilamos los siguientes datos personales: nombre completo, dirección de correo electrónico, DNI/NIE y fecha de nacimiento de los asistentes a los eventos. Estos datos son necesarios para la gestión de las entradas y el acceso a los eventos.'
          },
          {
            title: '3. Finalidad del tratamiento',
            content: 'Los datos personales se utilizan para: gestionar la compra y emisión de entradas, verificar la identidad de los asistentes en el acceso a los eventos, comunicaciones relacionadas con las entradas adquiridas y cumplir con las obligaciones legales aplicables.'
          },
          {
            title: '4. Base legal',
            content: 'El tratamiento de tus datos se basa en la ejecución del contrato de compraventa de entradas y el cumplimiento de obligaciones legales. En algunos casos, el tratamiento se basa en tu consentimiento explícito.'
          },
          {
            title: '5. Conservación de los datos',
            content: 'Conservamos tus datos personales durante el tiempo necesario para cumplir con las finalidades para las que fueron recogidos, incluyendo el cumplimiento de obligaciones legales, contables o de información.'
          },
          {
            title: '6. Derechos del usuario',
            content: 'Tienes derecho a acceder, rectificar y suprimir tus datos, así como otros derechos reconocidos en el Reglamento General de Protección de Datos (RGPD). Puedes ejercer estos derechos contactando con nosotros en info@galiticket.es.'
          },
          {
            title: '7. Seguridad de los datos',
            content: 'Aplicamos medidas técnicas y organizativas apropiadas para proteger tus datos personales contra el acceso no autorizado, la alteración, divulgación o destrucción. Todos los datos se transmiten mediante conexiones cifradas HTTPS.'
          },
          {
            title: '8. Cookies',
            content: 'Utilizamos cookies propias y de terceros para mejorar la experiencia de usuario. Puedes configurar tu navegador para rechazar las cookies, aunque esto puede afectar al funcionamiento de la plataforma.'
          },
          {
            title: '9. Cambios en la política de privacidad',
            content: 'Nos reservamos el derecho de modificar esta política de privacidad para adaptarla a novedades legislativas o cambios en nuestros servicios. Te notificaremos cualquier cambio significativo a través de la plataforma.'
          },
        ].map((section, index) => (
          <div key={index} style={{ marginBottom: isMobile ? '1.5rem' : '2rem' }}>
            <h2 style={{ color: colors.text, fontSize: isMobile ? '1rem' : '1.1rem', fontWeight: 'bold', marginBottom: '0.8rem' }}>{section.title}</h2>
            <p style={{ color: colors.textSecondary, fontSize: isMobile ? '0.9rem' : '0.95rem', lineHeight: 1.8 }}>{section.content}</p>
          </div>
        ))}

      </div>
    </div>
  );
}

export default Privacy;